import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { ReduxNext, ReduxStore } from '@makemydeal/dr-shared-store';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { OFFER_SAVE_SUCCESS } from '../actionTypes/offerActionTypes';
import { SHOPPER_URLS_SUCCESS } from '../actionTypes/shopperUrlsActionTypes';
import { appendSciLink } from '../utils/amdShareLinkUtils';

export const middleware = (store: ReduxStore<StateTree>) => (next: ReduxNext) => (action: AnyFSA) => {
    if (action.type !== OFFER_SAVE_SUCCESS && action.type !== SHOPPER_URLS_SUCCESS) {
        return next(action);
    }

    if (!action.payload.creditAppUrl && !action.payload.docUploadDeepLinkUrl) {
        return next(action);
    }

    const state = store.getState();
    const enableSciLink = featureToggleSelectors.isAmdShareLinkEnabled(state) && !dealerSelectors.isAmdEnabledDealer(state);

    if (!enableSciLink) {
        return next(action);
    }

    return next({
        ...action,
        payload: {
            ...action.payload,
            creditAppUrl: appendSciLink(action.payload.creditAppUrl),
            docUploadDeepLinkUrl: appendSciLink(action.payload.docUploadDeepLinkUrl)
        }
    });
};
